import React, { useState, useEffect } from "react";
import PageHeader1 from "../../components/common/PageHeader1";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { GetMusicListApi, handleDeleteMusic } from "../../services/MeditationBackgroundMusic";

function MusicList() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [musicList, setMusicList] = useState([]);

  const columns = [
    {
      field: "sno",
      headerName: "S.No.",
      width: 100,
    },
    {
      field: "meditation_background_music_category",
      headerName: "Meditation Background Music Category",
      flex: 1,
    },
    {
      field: "audioUrl",
      headerName: "Audio",
      flex: 1,
      renderCell: (params) => (
        <audio controls style={{ height: "30px" }} preload="none" src={params.row.audioUrl}>
          Your browser does not support the audio element.
        </audio>
      ),
    },
    {
      field: "action",
      headerName: "ACTION",
      width: 150,
      renderCell: (params) => (
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-outline-primary ms-2 mt-2"
            onClick={() => navigate(`/edit-background-music/${params.row._id}`)}
          >
            <i className="icofont-ui-edit"></i>
          </button>
          <button
            type="button"
            className="btn btn-outline-danger mt-2"
            onClick={() => handleDeleteMusic(params.row._id, fetchMusicList)}
          >
            <i className="icofont-ui-delete"></i>
          </button>
        </div>
      ),
    },
  ];

  async function fetchMusicList() {
    setIsLoading(true);
    try {
      const response = await GetMusicListApi();
      if (response && response.data) {
        setMusicList(
          response.data.map((item, i) => ({
            ...item,
            id: item._id,
            sno: i + 1,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching music list:", error);
      toast.error("Failed to fetch music list");
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchMusicList();
  }, []);

  return (
    <div className="body d-flex py-lg-3 py-md-2">
      <div className="container-xxl">
        <PageHeader1
          pagetitle="Meditation Background Music"
          modalbutton={() => (
            <div className="col-auto d-flex w-sm-100">
              <button
                type="button"
                className="btn btn-primary btn-set-task w-sm-100"
                onClick={() => navigate("/create-background-music")}
              >
                <i className="icofont-plus-circle me-2 fs-6"></i>Add Music
              </button>
            </div>
          )}
        />

        <div className="row clearfix g-3">
          <div className="col-sm-12 mt-3">
            <div className="card">
              <div className="card-body">
                <div style={{ height: 500, width: '100%' }}>
                  <DataGrid
                    rows={musicList}
                    columns={columns}
                    loading={isLoading}
                    pageSize={8}
                    rowsPerPageOptions={[8, 10, 25]}
                    pagination
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MusicList;
